"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContextIdsFromUrl = getContextIdsFromUrl;
/**
 * Extracts teamId, eventId, and broadcastId from a given URL string.
 *
 * @param {string} url - The full URL string to extract IDs from.
 * @returns {Object} An object containing extracted IDs.
 * @returns {string} return.teamId - The extracted team ID.
 * @returns {string} return.eventId - The extracted event ID.
 * @returns {string} return.broadcastId - The extracted broadcast ID.
 */
function getContextIdsFromUrl(url) {
  // Break the URL into parts and remove any empty strings
  var segments = url.split('/').filter(Boolean);
  return {
    teamId: segments[segments.indexOf('teams') + 1],
    eventId: segments[segments.indexOf('events') + 1],
    broadcastId: segments[segments.indexOf('broadcasts') + 1]
  };
}